import { getPreviewUrlService } from "@/services/commonService"
import { router } from '@/router/router'

export function formatTimeStr(time) {
  let temp;
  try {
    if (typeof time == "number") {
      temp = new Date(time);
    } else if (typeof time == "string") {
      temp = new Date(time);
    } else if (time instanceof Date) {
      temp = time;
    } else {
      throw new Error("日期格式不正确");
    }
  } catch (error) {
    return "";
  }
  let year = temp.getFullYear();
  let month = temp.getMonth() + 1;
  let date = temp.getDate();
  let hour = temp.getHours();
  let minute = temp.getMinutes();
  let second = temp.getSeconds();
  return (
    [year, month, date].map(formatNumber).join("/") +
    " " +
    [hour, minute, second].map(formatNumber).join(":")
  );
}

export function formatYMDstr(time) {
  if (!time) {
    return '';
  }
  let temp;
  try {
    if (typeof time == "number") {
      temp = new Date(time);
    } else if (typeof time == "string") {
      temp = new Date(time);
    } else if (time instanceof Date) {
      temp = time;
    } else {
      throw new Error("日期格式不正确");
    }
  } catch (error) {
    console.log(error.message);
    return "";
  }
  let year = temp.getFullYear();
  let month = temp.getMonth() + 1;
  let date = temp.getDate();
  return [year, month, date].map(formatNumber).join("-");
}

const formatNumber = (n) => {
  n = n.toString();
  return n[1] ? n : "0" + n;
};

export function dateStr2Date(str) {
  if (!str) {
    return '';
  }
  try {
    if (str instanceof Date) {
      return str;
    } else {
      let date = new Date(str);
      return date;
    }
  } catch (error) {
    return undefined;
  }
}

//文件预览
export function previewFile(index, row, type) {
  let reqParam = {
    filePath: row.resource,
  };
  switch (type) {
    case 'document':
      reqParam.filePath = row.attachmentItem;
      break
    default:
      reqParam.filePath = row.resource;
      break
  }
  getPreviewUrlService(reqParam).then(
    (res) => {
      if (res.code == 10000000) {
        let filePath = res.data;
        if (row.name.indexOf("xls") != -1 ||
          row.name.indexOf("xslx") != -1 ||
          row.name.indexOf("xlsx") != -1) {
          window.open(filePath, "_blank");
        } else if (
          row.name.indexOf("doc") != -1 ||
          row.name.indexOf("docx") != -1 ||
          row.name.indexOf("pdf") != -1 ||
          row.name.indexOf("jpg") != -1 ||
          row.name.indexOf("png") != -1 ||
          row.name.indexOf("jpeg") != -1
        ) {
          let routeData = router.resolve({
            path: "/overviewFile",
            query: { filePath: filePath, fileName: row.name },
          });
          window.open(routeData.href, "_blank");
        } else {
          this.$alert("当前文件类型暂不支持预览", "提示", {
            confirmButtonText: "确定",
          });
        }
      } else {
        this.$alert(res.msg, "提示", {
          confirmButtonText: "确定",
        });
      }
    },
    (err) => {
      this.$alert("系统异常", "提示", {
        confirmButtonText: "确定",
      });
    }
  );

  // window.open(row.resource, "_blank");
  // window.location.href = row.url;
};